(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gp-compare-products"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initCompare(){
    var root=document.getElementById('gp-compare'),source=document.getElementById('gp-compare-data');
    if(!root||!source)return;
    var data;try{data=JSON.parse(source.textContent)}catch(e){return}
    var category=document.getElementById('gp-compare-category'),selectors=Array.from(root.querySelectorAll('.gp-compare-select')),results=document.getElementById('gp-compare-results');
    function fill(){
      var a=data[category.value]||[];
      selectors.forEach(function(s,i){s.textContent='';var none=document.createElement('option');none.value='';none.textContent='Choose product '+(i+1);s.appendChild(none);a.forEach(function(p,j){var opt=document.createElement('option');opt.value=String(j);opt.textContent=p.title;s.appendChild(opt)})});
      draw();
    }
    function cell(row,label,value,href){
      var c=row.insertCell(-1);if(href){var a=document.createElement('a');a.href=href;a.textContent=value;c.appendChild(a)}else{c.textContent=value||'Not provided'}return c;
    }
    function draw(){
      var a=data[category.value]||[],chosen=selectors.map(function(s){return s.value===''?null:a[Number(s.value)]}).filter(Boolean);
      var seen=new Set();chosen=chosen.filter(function(p){if(seen.has(p.url))return false;seen.add(p.url);return true});
      results.textContent='';if(!chosen.length){var p=document.createElement('p');p.textContent='Select up to three products to compare.';results.appendChild(p);return}
      var scroller=document.createElement('div');scroller.className='gp-compare__scroll';var table=document.createElement('table');var tr=table.insertRow(-1);var th=document.createElement('th');th.scope='col';th.textContent='Specification';tr.appendChild(th);
      chosen.forEach(function(p){var th=document.createElement('th');th.scope='col';th.textContent=p.title;tr.appendChild(th)});
      [['Price','price'],['Brand / Seller','vendor'],['Product category','type'],['Listed SKU','sku'],['Description','summary']].forEach(function(field){var row=table.insertRow(-1);var h=document.createElement('th');h.scope='row';h.textContent=field[0];row.appendChild(h);chosen.forEach(function(p){cell(row,field[0],p[field[1]])})});
      var row=table.insertRow(-1),h=document.createElement('th');h.scope='row';h.textContent='Product page';row.appendChild(h);chosen.forEach(function(p){cell(row,'Product page','View details',p.url)});
      var note=table.insertRow(-1),nh=document.createElement('th');nh.scope='row';nh.textContent='Availability / Warranty';note.appendChild(nh);chosen.forEach(function(){cell(note,'','Confirm supplier stock, lead time, and warranty before payment')});
      scroller.appendChild(table);results.appendChild(scroller);
    }
    category.addEventListener('change',fill);selectors.forEach(function(s){s.addEventListener('change',draw)});fill()
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initCompare);else initCompare();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-complements"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('product-recommendations'))customElements.define('product-recommendations',class extends HTMLElement{
 connectedCallback(){if(this.dataset.gpLoaded)return;var io;if('IntersectionObserver' in window){io=new IntersectionObserver((items)=>{if(items.some(x=>x.isIntersecting)){io.disconnect();this.load()}},{rootMargin:'320px'});io.observe(this)}else this.load()}
 load(){if(this.dataset.gpLoaded)return;this.dataset.gpLoaded='true';fetch(this.dataset.url).then(r=>r.ok?r.text():Promise.reject(new Error('Recommendation request failed'))).then(html=>{var doc=new DOMParser().parseFromString(html,'text/html');var block=doc.querySelector('product-recommendations');if(block&&block.innerHTML.trim())this.innerHTML=block.innerHTML}).catch(()=>{this.hidden=true})}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-consultation-form"] && !Shopify.designMode) return;
  try {
    
(function(){
 function attributeGPSource(){
   var f=document.getElementById('gp-rfq-intake');if(!f)return;
   var qs=new URLSearchParams(location.search), map=[['gp-utm-source','utm_source'],['gp-utm-medium','utm_medium'],['gp-utm-campaign','utm_campaign'],['gp-source-product','product']];
   map.forEach(function(pair){var el=document.getElementById(pair[0]);if(!el)return;var value=qs.get(pair[1])||'';el.value=value.slice(0,240)});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',attributeGPSource);else attributeGPSource();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
